import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Wrapper } from './style';
import logo from '../../assets/intro/logo.svg';
import NavItems from './NavItems/NavItems';
import * as UIActions from '../../redux/actions/UI';

const itemList = [
  {
    title: 'Overview',
    items: [
      {
        item: 'Introduction',
        route: 'introduction',
      },
      {
        item: 'Brand Assets',
        route: 'brand-assets',
      },
    ],
  },
  {
    title: 'Guidelines',
    items: [
      {
        item: 'Colors',
        route: 'colors',
      },
      {
        item: 'Elevation',
        route: 'elevation',
      },
      {
        item: 'Icons',
        route: 'icons',
      },
      {
        item: 'Typography',
        route: 'typography',
      },
    ],
  },
  {
    title: 'Components',
    items: [
      {
        item: 'Breadcrumb',
        route: 'breadcrumb',
      },
      {
        item: 'Buttons',
        route: 'buttons',
      },
      {
        item: 'Cards',
        route: 'cards',
      },
      {
        item: 'Controls',
        route: 'controls',
      },
      {
        item: 'Dropdown Menu',
        route: 'dropdown-menu',
      },
      {
        item: 'Graphs',
        route: 'graphs',
      },
      {
        item: 'Inputs',
        route: 'inputs',
      },
      {
        item: 'Modals',
        route: 'modals',
      },
      {
        item: 'Profile Dropdown',
        route: 'profile-dropdown',
      },
      {
        item: 'Sidebar Headers',
        route: 'sidebar-headers',
      },
      {
        item: 'Snackbar',
        route: 'snackbar',
      },
      {
        item: 'Subcategories List',
        route: 'subcategories-list',
      },
      {
        item: 'Tables',
        route: 'tables',
      },
      {
        item: 'Tabs',
        route: 'tabs',
      },
      {
        item: 'Tooltips',
        route: 'tooltips',
      },
    ],
  },
];

const MenuBar = ({ sidebarState, setSidebarState, toggleGralBKdrop }) => {
  // handle click outside
  const node = useRef();
  const vpWidth = window.innerWidth;

  const handleClick = useCallback(
    e => {
      setTimeout(() => {
        if (node.current && (node.current.isEqualNode(e.target) || node.current.contains(e.target))) {
          return;
        }
        setSidebarState(false);
        // setExpanded(false);
        toggleGralBKdrop(false);
      }, 100);
    },
    [setSidebarState, toggleGralBKdrop]
  );

  useEffect(() => {
    if (vpWidth <= 767) {
      if (sidebarState) {
        document.addEventListener('mouseup', handleClick);
      }
      return () => {
        document.removeEventListener('mouseup', handleClick);
      };
    }
  }, [handleClick, sidebarState, vpWidth]);

  //

  return (
    <Wrapper ref={node} expanded={sidebarState}>
      <Link to="/" scroll>
        <img src={logo} alt="logo" />
      </Link>
      <NavItems itemList={itemList} />
    </Wrapper>
  );
};

const mapStateToProps = ({ UI }) => ({
  backdropState: UI.showBkDrop,
  sidebarState: UI.sidebarState,
});

const mapDispatchToProps = dispatch => ({
  toggleGralBKdrop: state => dispatch(UIActions.setBKDrop(state)),
  setSidebarState: state => dispatch(UIActions.setSidebarState(state)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuBar);
